import { styled } from '@mui/material/styles';
import { LabPlainList } from './HandsOnLabCard.styles';

// Section cards reuse the Case Study look; lists reuse the Hands-on Lab pieces.

// "What you will need": an empty checkbox before each item (static, so it prints the same).
export const OverviewChecklist = styled(LabPlainList)`
  li::before {
    content: '\\2610';
    margin-right: 8px;
    color: #0097B2;
  }
`;

// One tool per row: name (or link) on top, role and why below.
export const OverviewToolList = styled(LabPlainList)`
  li + li {
    margin-top: 10px;
  }
`;
